import { Component, Injector, Input, OnInit } from '@angular/core';
import { Asegurado } from 'src/app/Models/asegurado-detalle';
import { Asistencia } from 'src/app/Models/asistencia';
import { Poliza } from 'src/app/Models/poliza';
import { Seguro } from 'src/app/Models/seguro';
import { AppInsightsService } from 'src/app/Services/appInsight.service';

@Component({
  selector: 'app-asistencias',
  templateUrl: './asistencias.component.html',
  styleUrls: ['./asistencias.component.css']
})
export class AsistenciasComponent implements OnInit {

  @Input()
  asistencias: Asistencia[];
  @Input()
  poliza: Poliza;
  asegurado: Asegurado;
  seguro: Seguro;

  constructor(private inj: Injector) { }

  ngOnInit(): void{
  }

  logEventVerAsistencias(): void{
    this.asegurado = JSON.parse(localStorage.getItem('asegurado'));
    this.seguro = JSON.parse(localStorage.getItem('miSeguro'));
    let fechaHoy = new Date();
    const appInsightService = this.inj.get(AppInsightsService);
    appInsightService.logEvent(`Click al ver asistencias: (rut: ${this.asegurado.Rut}, Nombres y apellidos: ${this.asegurado.Nombre}, Patente: ${this.seguro.poliza.patente}, Fecha Hora: ${fechaHoy.toString()})`);
  }
}
